import { css } from '@emotion/core';

export const skeletonLoader = css`
    opacity: 0.3;
    padding: 25px;
    margin-top: 10%;
`;
